import component from './toolsI18nWizardsCatalog.vue'

export default component
